import React from "react"

const AstriaContext = React.createContext(null as any)

export default AstriaContext